import React from 'react'
import { connect } from 'react-redux'

// Components
import Loader from '../../utils/Loader'
import ErrorText from '../../utils/error-success/ErrorText'
import SectionBanner from '../../utils/SectionBanner'
import SectionFooter from '../../utils/SectionFooter'
import ReviewPreviewItem from './ReviewPreviewItem'
import ConfirmRegistrationDialog from '../../utils/dialogs/ConfirmRegistrationDialog'

// CSS
import '../../../css/sections/sections.css'
import '../../../css/event-listing-box.css'

// State
import { getReviews } from '../../../store/actions/reviews'
import {
	registerReviewerToRegistration,
	clearRegistrationResults,
} from '../../../store/actions/registration'

class ReviewsListing extends React.PureComponent {
	constructor(props) {
		super(props)

		this.state = {
			reviewBeingProcessed: null,
			showRegistrationConfirmationDialog: false,
		}
	}
	static initialAction(store, props, translationKey = null) {
		let res = store !== null ? getReviews(null, false, 3) : props.getReviews(null, false, 3)
		return res
	}

	componentDidMount() {
		if (!this.props.reviews.reviews) {
			ReviewsListing.initialAction(null, this.props)
		}
	}

	renderItems = () => {
		const { translations, reviewer } = this.props
		const { reviews } = this.props.reviews

		if (!reviews || !reviews.length) {
			return (
				<div className='section-content'>
					<div className='strong-text'>
						{translations.sections.reviews_listing.no_reviews_response}
					</div>
				</div>
			)
		}

		// Filter out reviews where review_full is 1
		const filteredReviews = reviews.filter(review => review.review_full !== 1)

		if (!filteredReviews.length) {
			return (
				<div className='section-content'>
					<div className='strong-text'>
						{translations.sections.reviews_listing.no_reviews_response}
					</div>
				</div>
			)
		}

		return filteredReviews.map((item, id) => {
			return (
				<ReviewPreviewItem
					key={id}
					item={item}
					reviewer={reviewer}
					registerHandler={reviewBeingProcessed =>
						this.setState({
							reviewBeingProcessed,
							showRegistrationConfirmationDialog: true,
						})
					}
				/>
			)
		})
	}

	render() {
		const { translations, registration } = this.props
		const { isLoading, error } = this.props.reviews

		return (
			<div className='section event-listing-box'>
				<SectionBanner bold={true}>{translations.sections.reviews_listing.title}</SectionBanner>
				<div className='news-listing-content section-content--dark-bg'>
					{isLoading ? (
						<div className='section-content'>
							<Loader />
						</div>
					) : error ? (
						<div className='section-content'>
							<ErrorText errors={error} />
						</div>
					) : (
						this.renderItems()
					)}
				</div>
				<SectionFooter href='/reviews/all'>
					{translations.sections.reviews_listing.footer_link}
				</SectionFooter>

				<ConfirmRegistrationDialog
					show={this.state.showRegistrationConfirmationDialog}
					inProgress={registration.inProcess}
					id={!!this.state.reviewBeingProcessed && this.state.reviewBeingProcessed.id}
					itemTitle={
						!!this.state.reviewBeingProcessed && this.state.reviewBeingProcessed.organization_name
					}
					handleAction={() =>
						this.props.registerReviewerToRegistration(this.state.reviewBeingProcessed.id)
					}
					handleClose={() => {
						this.props.clearRegistrationResults()
						this.setState({ showRegistrationConfirmationDialog: false })
					}}
					errors={registration.error}
					success={registration.success}
				/>
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		translations: state.translations.translations,
		registration: state.registration,
		reviewer: state.user.reviewer,
		reviews: state.reviews,
	}
}

export default connect(mapStateToProps, {
	getReviews,
	registerReviewerToRegistration,
	clearRegistrationResults,
})(ReviewsListing)



// WEBPACK FOOTER //
// ./src/components/home/reviews/ReviewsListing.js